import React, { Component } from 'react';

import { Link, NavLink } from 'react-router-dom';
import { contentStyles } from './styles';
import  cloneDeep from 'lodash/cloneDeep';


/*

Props:

• mainTitleText
• mainTitleTextAlt
• subTitleText
• bodyText
• style
• img
• imgWidth
• backgroundImageURL

*/

// let componentStyles = {...contentStyles};

const _applyStyleModifiers = (props) => {
    const clonedStyles = cloneDeep(contentStyles);
    const componentStyles = clonedStyles; 
    // const { backgroundImageURL } = props;
    
    componentStyles.container = (props.backgroundImageURL) 
        // Clone existing style object and add new props to the clone
        ? { ...componentStyles.container, backgroundImage: `url(${props.backgroundImageURL})`} 
        : { ...componentStyles.container, backgroundImage: null };

    componentStyles.subTitle = (props.subTitleColor) 
        // Clone existing style object and add new props to the clone
        ? { ...componentStyles.subTitle, color: props.subTitleColor} 
        : { ...componentStyles.subTitle };
        
    componentStyles.contentBodyText = (props.bodyTextColor) 
        // Clone existing style object and add new props to the clone
        ? { ...componentStyles.contentBodyText, color: props.bodyTextColor} 
        : { ...componentStyles.contentBodyText };
   
        componentStyles.contentBodyText = (props.bodyTextSize) 
        // Clone existing style object and add new props to the clone
        ? { ...componentStyles.contentBodyText, fontSize: props.bodyTextSize} 
        : { ...componentStyles.contentBodyText };

    componentStyles.flexDirection = (props.flexDirection) 
        // Clone existing style object and add new props to the clone
        ? { ...componentStyles.flexDirection, flexDirection: props.flexDirection} 
        : { ...componentStyles.flexDirection };

       
    // return {...componentStyles};

    return { ...componentStyles, container: {...componentStyles.container, ...props.style} };
}
// console.log(this.props.backgroundImageURL)

const _stringModifier = (props, state, styles) => {
    let modifiedTitle = props.mainTitleText;
    
    // console.log('%cHEIGHT','color: deeppink');
    // console.log(state.titleHeight);
    
    if(props.mainTitleText && state.titleHeight < 65){
        if (props.mainTitleTextAlt) {
            styles.mainTitleOnly.display = 'inline';
            modifiedTitle = props.mainTitleText + ' | ';
        }
    } else if(props.mainTitleText && state.titleHeight > 65) {
        if (props.mainTitleTextAlt) {
            styles.mainTitleOnly.display = 'block';
            modifiedTitle = props.mainTitleText;
        }
    } else {
        modifiedTitle = '';
    }

    return modifiedTitle;
}
// const styles = {...componentStyles, ..._applyStyleModifiers(props)}

export class Content extends Component {
    

    constructor(props){
        super(props);
        this.state={
            titleHeight: null,
            isHovered: null
        }
    }

    getTitleHeight = () => {
        const titleHeight = document.getElementById("contentTitle").clientHeight;
        // console.log('HEIGHT IS:', titleHeight);

        this.setState({
            titleHeight: titleHeight
        }, 
        ()=>{
            // console.log(this.state);
        });
    }

    handleResize = () => {
        this.getTitleHeight();
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        this.getTitleHeight();
    }
    
    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }
    
    // handleMouseEnter = () => {
    //     this.setState({
    //         isHovered: true
    //     })
    //     console.log('MOUSE HAS ENTERED CONTENT AREA');
    //     styles.container.transform = 'scale(1.01)'
        
    // }
    // handleMouseLeave = () => {
    //     this.setState({
    //         isHovered: false
    //     })
    //     console.log('MOUSE HAS LEFT CONTENT AREA');
    //     styles.container.transform = 'scale(1)'
    // }

    render() {
        // console.log( ..._applyStyleModifiers(this.props), 'modifiers');
        
        const styles = _applyStyleModifiers(this.props);
        // console.log('styles', _applyStyleModifiers(this.props))
        // const styles = { ...componentStyles, ..._applyStyleModifiers(this.props) };
        const mainTitleText = _stringModifier(this.props, this.state, styles);
            // TODO: Convert string into array of paragraphs using const myArray = this.props.bodyText.split('\n') then loop over array adding div for each with required spacing
        
        return (
            
                <div 
                    onMouseEnter={this.handleMouseEnter} 
                    onMouseLeave={this.handleMouseLeave} 
                    style={ styles.container }
                >
                    <span id="contentTitle" style={ styles.mainTitle }>
                        {this.props.mainTitleText && <span style={{...styles.mainTitle, ...styles.mainTitleContainer, ...styles.mainTitleOnly}}>
                            { mainTitleText }
                        </span>}
                        {this.props.mainTitleTextAlt && <span style={{...styles.mainTitleAlt, ...styles.mainTitleContainer}}>
                            {this.props.mainTitleTextAlt}
                        </span>}
                    </span>
    
                    { this.props.subTitleText && <span style={ styles.subTitle }>
                        { this.props.subTitleText }
                    </span>}
    
                    { this.props.bodyText && <span style={ styles.contentBodyText }>
                        { this.props.bodyText }
                    </span>}
                    { this.props.img && <img src={this.props.img} width={this.props.imgWidth} /> }

    
                    <div>{this.props.children}</div>
                </div>
            
        );
    }
};


// WEBPACK FOOTER //
// ./src/js/components/Content/Content.jsx